<template>
 <svg :style="style" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_4253_85446)">
<path id="Vector" d="M30.0426 29.4371L3.69062 3.1011C3.16262 2.5731 2.29863 2.5731 1.78662 3.1011C1.25863 3.6131 1.25863 4.4771 1.78662 5.0051L28.1226 31.3411C28.6506 31.8691 29.5146 31.8691 30.0266 31.3411C30.5546 30.8131 30.5546 29.9651 30.0426 29.4371ZM17.3866 12.9571V2.5731C17.3866 1.6131 16.6186 0.829102 15.6586 0.829102C14.6986 0.829102 13.9306 1.6131 13.9306 2.5731V9.4851L17.3866 12.9571Z" fill="white"/>
<path id="Vector_2" d="M13.9321 13.3091V13.5651H12.7641V12.1411L9.29214 8.66907V18.2851C9.29214 18.2851 6.31614 14.7811 6.10814 14.6371C4.42814 13.4531 2.52414 14.8771 3.80414 17.1331C4.54014 18.4291 10.2841 27.2451 10.2841 27.2451C11.1481 28.1251 12.3161 28.9251 13.5641 28.9251H22.1241C24.0761 28.9251 25.6921 27.5331 26.3481 25.7251L13.9321 13.3091ZM26.6521 22.2051V7.19707C26.6521 6.23707 25.8841 5.46907 24.9081 5.46907C23.9481 5.46907 23.1641 6.23707 23.1641 7.19707V13.5651H22.0121V3.72507C22.0121 2.76507 21.2281 1.99707 20.2841 1.99707C19.3401 1.99707 18.5561 2.78107 18.5561 3.72507V13.5651H18.0121L26.6521 22.2051ZM12.7641 8.31707V5.46907C12.7641 4.50907 11.9801 3.74107 11.0361 3.74107C10.2681 3.74107 9.61214 4.25307 9.38814 4.94107L12.7641 8.31707Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4253_85446">
<rect width="32" height="32" fill="white" transform="translate(0.779297 0.172852)"/>
</clipPath>
</defs>
</svg>






</template>

<script>
export default {
  name: 'icon-sbjbx',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>